import React from 'react';
import { Row, Col } from 'reactstrap';

const ContactsTab = () => {
  return (
    <Row>
      <Col md={12}>
        <div className="text-center p-4">
          <h5>Contacts</h5>
          <p className="text-muted">Account contacts content will be implemented here.</p>
        </div>
      </Col>
    </Row>
  );
};

export default ContactsTab; 